<template>
    <div>
        <base-table
            hide-default-footer
            v-bind="$attrs"
            v-on="$listeners"
            :headers="processedHeaders"
            :items="processedItems"
            :options="options"
            @click:row="onRowItemClick">

            <template v-slot:[`item.date`]="{ item }">
                <span v-if="item.visibilityType === 'one-time'">
                    {{ !item.date[0] && !item.date[1] ? '': `${$util.getDDMMYYYYHHSSDateFormat(item.date[0])} ~ ${$util.getDDMMYYYYHHSSDateFormat(item.date[1])}` }}
                </span>
                <span v-else-if="item.visibilityType === 'recurring-daily'">
                    {{ !item.date[0] && !item.date[1] ? '': `${$util.getHHSSDateFormat(item.date[0])} ~ ${$util.getHHSSDateFormat(item.date[1])}`}}
                </span>
            </template>
            <template v-slot:[`item.visibilityType`]="{ item }">
                <span>
                    {{ $t(`ticketVisibility.visibilityType.${item.visibilityType}`)  }}
                </span>
            </template>
        </base-table>
    </div>
</template>

<script>
import BaseTable from '@/components/tables/BaseTable'
import { TableMixinFactory } from '@/mixins/TableMixin'

export default {
    name: 'BookingTable',

    components: {
        BaseTable
    },

    mixins: [
        TableMixinFactory({
            itemMapFunc: function (item) {
                return {
                    ...item,
                    date: [item.fromDate, item.toDate]
                }
            }
        })
    ],

    props: {
        items: {
            type: Array,
            default: () => []
        },

        options: {
            type: Object,
            default: () => ({})
        }
    },

    data () {
        return {
            headers: [
                {
                    text: this.$t('ticketVisibility.table.header.type'),
                    value: 'type',
                    sortable: false
                },
                {
                    text: this.$t('ticketVisibility.table.header.visibilityType'),
                    align: 'center',
                    value: 'visibilityType'
                },
                {
                    text: this.$t('ticketVisibility.table.header.date'),
                    value: 'date'
                }
            ]
        }
    },

    methods: {
        onRowItemClick (item) {
            this.$emit('viewDetails', JSON.parse(JSON.stringify(item)))
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
